import { AbstractModel, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { TollReviewStatus } from './toll-review-status';

@inheritSerialization(AbstractModel)
export class TollReimbursement extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserializeAs(TollReviewStatus)
  tollReviewStatus: TollReviewStatus;

  @autoserialize
  automaticTollDetectionEnabled: boolean;

  @autoserialize
  onCreateTollEstimate: number;

  @autoserialize
  inProgressTollEstimate: number;

  @autoserialize
  onCompleteTollEstimate: number;

  @autoserialize
  driverTollRequestAmount: number;

  @autoserialize
  driverPaidAmount: number;

  @autoserializeAs(Date)
  reviewedAt: Date;

  @autoserialize
  reviewedByUserId: number;

  static OnSerialized(instance: TollReimbursement, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.reviewedAt)) {
      json.reviewedAt = DateUtil.serializeDate(instance.reviewedAt);
    }
  }

  static OnDeserialized(instance: TollReimbursement, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['reviewedAt'])) {
      instance.reviewedAt = DateUtil.deserializeDate(json['reviewedAt']);
    }
  }
}
